import React, { Fragment } from 'react'
import moment from 'moment'
import DisplayName from './DisplayName'
import { Svg } from '../../application'
import styled from 'react-emotion'

const WithIcon = styled('span')`
  margin-right: 15px;
  display: inline-block;
  text-transform: capitalize;
  svg {
    margin-right: 5px;
  }
`

const TravelDates = ({ startDate, endDate }) => {
    const s = moment(startDate)
    const e = moment(endDate)

    let output = ''
    if (e.isValid())
        output = e.format('D MMMM YYYY')

    if (s.isValid())
        output = s.format('D MMMM YYYY')

    if (s.isValid() && e.isValid()) {
        const isSameYear = s.isSame(e, 'year')
        const isSameMonth = s.isSame(e, 'month')

        let format = 'D MMMM YYYY'

        if (isSameYear && isSameMonth)
            format = 'D'

        if (isSameYear && !isSameMonth)
            format = 'D MMMM'

        output = `${s.format(format)} - ${e.format('D MMMM YYYY')}`
    }
    return (
        <WithIcon>
            <Svg icon="calendar" />
            {output}
        </WithIcon>
    )
}

const RoomType = ({ rooms }) => {
    if (!rooms || rooms.length === 0)
        return null

    const uniqueRooms = rooms
        .reduce((acc, curr) => {
            if (!curr.categoryName)
                return acc
            if (!acc.hasOwnProperty[curr.categoryName])
                acc[curr.categoryName] = {
                    name: `1 ${curr.categoryName}`,
                    count: 1
                }
            else {
                acc[curr.categoryName].name = `${acc[curr.categoryName].count + 1} ${curr.categoryName}`
                acc[curr.categoryName].count += 1
            }

            return acc;
        }, {})

    let roomDetails = []
    for (let prop in uniqueRooms) {
        roomDetails.push(`${uniqueRooms[prop].name}`)
    }

    if (roomDetails.length === 0)
        return null

    return (
        <WithIcon>
            <Svg icon="bed" />
            {roomDetails.join(', ')}
        </WithIcon>
    )
}

const Passengers = ({ passengers }) => {
    if (!passengers)
        return null
    return (
        <WithIcon>
            <Svg icon={passengers === 1 ? "user" : (passengers > 2 ? "user-family" : "user-couple")} />
            {passengers}
        </WithIcon>
    )
}

export default ({ product, startDate}) => {
    const { endDate, rooms } = product
    const passengers = rooms ? rooms.reduce((acc, cur) => { return acc + cur.passengers }, 0) : null

    if (product.adHoc) {
        var a = moment(product.endDate)
        var b = moment(product.startDate)
        product.queryString = `/?arrivalDate=${product.startDate}&duration=${a.diff(b, 'days')}&travellers=30,30`
    }

    return (
        < Fragment >
            <div>
                <DisplayName {...product} />
            </div>
            <div>
                <TravelDates startDate={startDate} endDate={endDate} />
                <Passengers passengers={passengers} />
                <RoomType rooms={rooms} />
            </div>
        </Fragment >
    )
}
